import type { CloudBluePlan } from "@gatsby-plugin-definitions/fragments/CloudBluePlan"
import type { OptionMapping } from "@gatsby-plugin-marketplace/fragments/optionMapping"
import type { PeriodName } from "../../../../lib/api/types"

/**
 * Resolves which CloudBluePlan actually offers the given period — the box's
 * own default plan (if one of its own periods already matches), or the plan
 * paired with a matching period in the AX Configuration's `optionsMapping`
 * (Squidex label "Opcje konfiguracji produktu"). Mirrors marketplace's
 * plan+period resolution (getSelectedPlanSettings), but matches directly on
 * each mapping entry's own `period` field instead of a config.controls-driven
 * options key, since boxes here are driven by the shared section-wide period
 * switcher, not a per-product Redux options state.
 * Returns undefined when no plan (default or mapped) offers the period at all.
 */
export function getCloudBluePlanForPeriod(
  defaultCloudBluePlan: CloudBluePlan[],
  optionsMapping: OptionMapping[] | undefined,
  period?: PeriodName
): CloudBluePlan | undefined {
  if (!period) {
    return defaultCloudBluePlan[0]
  }

  const matchingDefaultPlan = defaultCloudBluePlan.find((plan) =>
    plan.flatData.periods.some((cbPeriod) => cbPeriod.period_name === period)
  )

  if (matchingDefaultPlan) {
    return matchingDefaultPlan
  }

  const matchingOption = (optionsMapping ?? []).find(
    (option) => option.period?.period === period
  )

  return matchingOption?.cloudBluePlan[0]
}
